let token = null
const metaToken = document.querySelector('meta[name="csrf-token"]')
if (metaToken) {
  token = metaToken.content
}

export const csrfToken = token
